module.exports = __webpack_public_path__ + "static/media/pngUploader.3cdccef7.png";